export default __webpack_public_path__ + "static/media/Thea_9781408335697.17077990.jpg";